<template>
	<b-container fluid>
		<b-navbar toggleable="lg" fixed="top" type="dark" class="addBackground">

		  <b-nav-toggle target="nav_collapse" id="special"></b-nav-toggle>

		  <b-collapse is-nav id="nav_collapse">

		  	<b-navbar-brand href="#"><router-link to="/"><img src="../assets/img/logo.png"></router-link></b-navbar-brand>

		    <b-nav is-nav-bar class="ml-auto">
		      <b-nav-item to="/" exact class="navSeparator" v-on:click="scrollTop()">HOME <div></div></b-nav-item>
		      <b-nav-item to="/about" class="navSeparator" v-on:click="scrollTop()">ABOUT ME <div></div></router-link></b-nav-item>
		      <b-nav-item to="/albums" class="navSeparator" v-on:click="scrollTop()">ALBUMS <div></div></b-nav-item>
		      <b-nav-item to="/service" class="navSeparator" v-on:click="scrollTop()">MY SERVICES <div></div></b-nav-item>
		      <b-nav-item to="/master" class="navSeparator" v-on:click="scrollTop()">MASTERPIECES <div></div></b-nav-item>
		      <b-nav-item to="/contact" class="navSeparator" v-on:click="scrollTop()">CONTACT <div></div></b-nav-item>
		    </b-nav>

		  </b-collapse>
		</b-navbar>
	</b-container>
</template>
<script>
export default {
  methods: {
  	toggleActive (event) {
       event.preventDefault()
  	},
  	hideMenu () {
  		this.$('#nav_collapse').removeClass('show')
  		this.$('#nav_collapse').css({ display: 'none' })
  	},
  	scrollTop () {
  		this.$(window).scrollTop(0)
  	}
  }
}
</script>
<style lang="scss" scoped>
.navSeparator {
	margin-right: 20px;
	color: #fa0707!important;
}

.nav-link {
	color: #fa0707!important;
	font-weight: bolder;
}

@media only screen and (max-width: 768px) {
	.navSeparator {
		margin-right: 0px;
		font-size: 15px;
		color: #fa0707!important;
	}	
}

.active {
	div {
		width: 45px;
	    height: 8px;
	    border-bottom: 1px solid red;
	    -webkit-transform:
	        translateY(-20px)
	        translateX(10px)
	        rotate(-45deg); 
	}
}

@media only screen and (max-width: 768px) {
    .addBackground {
      background-color: #000000;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue?a134f980